import { render, staticRenderFns } from "./HeaderAvatarMenu.vue?vue&type=template&id=4e722040&"
import script from "./HeaderAvatarMenu.vue?vue&type=script&lang=js&"
export * from "./HeaderAvatarMenu.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAvatarMenu.vue?vue&type=style&index=0&id=4e722040&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports